// App.jsx
import { useEffect, useState } from "react";
import { T } from "./Tokens";
import { USER_ID } from "./config";
import { GlobalStyles } from "./components/UI";
import History from "./pages/History";
import Chat from "./pages/Chat";
import AboutUs from "./pages/AboutUs";
import News from "./pages/News";

// ── Navbar ───────────────────────────────────────────────────────
function Navbar({ view, setView, activeSession, onNewSession }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const navItems = [
    {
      id: "news",
      label: "News",
      path: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 7h10v2H7zm0 4h10v2H7zm0 4h6v2H7z",
    },
    {
      id: "chat",
      label: "Chat",
      path: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z",
    },
    {
      id: "history",
      label: "History",
      path: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z",
    },
    {
      id: "about",
      label: "About Us",
      path: "M11 9h2V7h-2v2zm1-7C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-5h2v-6h-2v6z",
    },
  ];

  return (
    <>
      <nav
        style={{
          background: T.bg1,
          borderBottom: `1px solid ${T.border}`,
          display: "flex",
          alignItems: "stretch",
          flexShrink: 0,
          height: 44,
          position: "relative",
          zIndex: 200,
        }}
      >
        {/* Logo */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            padding: "0 16px",
            borderRight: `1px solid ${T.border}`,
            flexShrink: 0,
          }}
        >
          <div
            style={{
              width: 22,
              height: 22,
              borderRadius: 5,
              background: T.greenDim,
              border: `1px solid ${T.greenBorder}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg width="11" height="11" viewBox="0 0 24 24" fill={T.green}>
              <path d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7z" />
            </svg>
          </div>
          <span
            style={{ fontSize: 11, color: T.textSecondary, fontWeight: 500 }}
          >
            FactoScope
          </span>
        </div>

        {/* Desktop links */}
        <div className="desktop-nav" style={{ display: "flex" }}>
          {navItems.map((item) => (
            <button
              key={item.id}
              className={`nav-btn ${view === item.id ? "active" : ""}`}
              onClick={() => setView(item.id)}
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d={item.path} />
              </svg>
              {item.label}
              {item.id === "chat" && activeSession && (
                <span className="hide-mobile" style={{ color: T.textDim }}>
                  · {activeSession}
                </span>
              )}
            </button>
          ))}
        </div>

        {/* Right side */}
        <div
          style={{
            marginLeft: "auto",
            display: "flex",
            alignItems: "center",
            gap: 8,
            paddingRight: 10,
            flexShrink: 0,
          }}
        >
          <span
            className="hide-mobile"
            style={{
              fontSize: 9,
              color: T.textDim,
              background: T.bg3,
              border: `1px solid ${T.border}`,
              borderRadius: T.radiusSm,
              padding: "2px 8px",
            }}
          >
            {USER_ID}
          </span>

          {/* New session button */}
          <button
            onClick={() => {
              onNewSession();
              setMenuOpen(false);
            }}
            style={{
              padding: "5px 10px",
              background: T.greenDim,
              border: `1px solid ${T.greenBorder}`,
              borderRadius: T.radius,
              color: T.greenText,
              fontSize: 10,
              cursor: "pointer",
              fontFamily: T.fontMono,
              display: "flex",
              alignItems: "center",
              gap: 5,
              flexShrink: 0,
              transition: "all 0.15s",
            }}
          >
            <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 13H13v6h-2v-6H5v-2h6V5h2v6h6v2z" />
            </svg>
            <span className="desktop-only">New session</span>
          </button>

          {/* Hamburger */}
          <button
            className="mobile-menu-btn"
            onClick={() => setMenuOpen((o) => !o)}
            style={{
              background: "none",
              border: `1px solid ${T.border}`,
              borderRadius: T.radiusSm,
              padding: "5px 7px",
              cursor: "pointer",
              color: T.textSecondary,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {menuOpen ? (
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
              </svg>
            ) : (
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
              </svg>
            )}
          </button>
        </div>
      </nav>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div
          className="mobile-dropdown"
          style={{
            position: "fixed",
            top: 44,
            left: 0,
            right: 0,
            background: T.bg1,
            borderBottom: `1px solid ${T.border}`,
            zIndex: 199,
            flexDirection: "column",
            display: "flex",
          }}
        >
          {navItems.map((item) => (
            <button
              key={item.id}
              className={`mobile-dropdown-item ${view === item.id ? "active" : ""}`}
              onClick={() => {
                setView(item.id);
                setMenuOpen(false);
              }}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d={item.path} />
              </svg>
              {item.label}
              {item.id === "chat" && activeSession && (
                <span style={{ color: T.textDim, fontSize: 11, marginLeft: 4 }}>
                  · {activeSession}
                </span>
              )}
            </button>
          ))}
        </div>
      )}
    </>
  );
}

export default function App() {
  const [view, setView] = useState("news");
  const [activeSession, setActiveSession] = useState(() => {
    return localStorage.getItem("activeSession") || null;
  });

  useEffect(() => {
    if (activeSession) {
      localStorage.setItem("activeSession", activeSession);
    } else {
      localStorage.removeItem("activeSession");
    }
  }, [activeSession]);

  const openSession = (sessionId) => {
    setActiveSession(sessionId);
    setView("chat");
  };

  const newSession = () => {
    setActiveSession(String(Date.now()).slice(-6));
    setView("chat");
  };

  const onSessionDeleted = (sessionId) => {
    if (activeSession === String(sessionId)) {
      setActiveSession(null);
    }
  };

  return (
    <>
      <GlobalStyles />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          background: T.bg0,
          fontFamily: T.fontMono,
        }}
      >
        <Navbar
          view={view}
          setView={setView}
          activeSession={activeSession}
          onNewSession={newSession}
        />

        <div style={{ flex: 1, overflow: "hidden" }}>
          {view === "history" ? (
            <History
              onOpenSession={openSession}
              onSessionDeleted={onSessionDeleted}
            />
          ) : view === "chat" ? (
            activeSession ? (
              <Chat key={activeSession} sessionId={activeSession} />
            ) : (
              <div style={{ padding: 20, color: T.textDim }}>
                Start a new session to begin chatting
              </div>
            )
          ) : view === "about" ? (
            <AboutUs />
          ) : view === "news" ? (
            <News />
          ) : null}
        </div>
      </div>
    </>
  );
}
